module.exports = __webpack_public_path__ + "img/CO443726.24951f09.png";